import { factory } from '../../../utils/apiThunkFactory.js';



export const changeStatus = factory.put('controlPanel/changeStatus', '/api/users/updateUserStatus');
export const updateMediaPersistence = factory.put('controlPanel/updateMediaPersistence', '/api/users/updateMediaPersistence');
export const isGuestInvitationEnabled = factory.get("MapDisplay/isGuestInvitationEnabled", `/api/tenants/guest-invitation-enabled`);
export const updatePhoto = factory.post("controlPanel/updatePhoto", "/api/users/update-photo/:userId");
export const deletePhoto = factory.post("controlPanel/deletePhoto", "/api/users/delete-photo/:userId");
export const getMattermostLaunchUrl = factory.get("controlPanel/getMattermostLaunchUrl","/api/mattermost/launch/:tenantId");
export const provisionMyTeam = factory.post("controlPanel/provisionMyTeam","/api/mattermost/provision-my-team/:tenantId");
export const isMattermostChatEnabled = factory.get("controlPanel/isMattermostChatEnabled","/api/tenants/mattermost-chat-enabled");